import { getData, postData } from '~/utils/service';
import type { ProfileSuggestionsResponse, RefreshProfileSuggestionsResponse } from './types';

export const PROFILE_SUGGESTIONS_ROUTES = {
  get: '/providers/{provider_id}/profile-suggestions',
  post: '/providers/{provider_id}/profile-suggestions/refresh',
};

export const getProfileSuggestions = (providerId: number) =>
  getData<ProfileSuggestionsResponse>('profileSuggestions', {
    pathParams: { provider_id: String(providerId) },
  });

export const refreshProfileSuggestions = (providerId: number) =>
  postData<RefreshProfileSuggestionsResponse>('profileSuggestions', {
    pathParams: { provider_id: String(providerId) },
  });
